import { SITE_CODE, type SiteCode } from '@olxpwa-lib/i18n/types';
import type { ApiEnv } from '~types';

const MAP_SITE_CODE_TO_ENDPOINTS_CONFIG: Record<SiteCode, Record<ApiEnv, string>> = {
  [SITE_CODE.OLXPL]: {
    production: 'https://jobs-api.olx.pl',
    staging: 'https://api.pl.jobs.stg.eu.olx.org',
  },
  [SITE_CODE.OLXRO]: {
    production: 'https://jobs-api.olx.ro',
    staging: 'https://api.ro.jobs.stg.eu.olx.org',
  },
  [SITE_CODE.OLXUA]: {
    production: 'https://jobs-api.olx.ua',
    staging: 'https://api.ua.jobs.stg.eu.olx.org',
  },
  [SITE_CODE.OLXKZ]: {
    production: 'https://jobs-api.olx.kz',
    staging: 'https://api.kz.jobs.stg.eu.olx.org',
  },
  [SITE_CODE.OLXUZ]: {
    production: 'https://jobs-api.olx.uz',
    staging: 'https://api.uz.jobs.stg.eu.olx.org',
  },
  [SITE_CODE.OLXPT]: {
    production: 'https://jobs-api.olx.pt',
    staging: 'https://api.pt.jobs.stg.eu.olx.org',
  },
  [SITE_CODE.OLXBG]: {
    production: 'https://jobs-api.olx.bg',
    staging: 'https://api.bg.jobs.stg.eu.olx.org',
  },
};

export const getEndpointPerMarket = (apiEnv: ApiEnv, siteCode: SiteCode) =>
  MAP_SITE_CODE_TO_ENDPOINTS_CONFIG[siteCode][apiEnv];

export const MAP_SITE_CODE_TO_DEFAULT_JOBS_CATEGORY_ID: Record<SiteCode, number | null> = {
  [SITE_CODE.OLXPL]: 4,
  [SITE_CODE.OLXRO]: 4,
  [SITE_CODE.OLXUA]: 6,
  [SITE_CODE.OLXKZ]: 6,
  [SITE_CODE.OLXUZ]: null, // TODO: NOT VERIFIED
  [SITE_CODE.OLXPT]: 190,
  [SITE_CODE.OLXBG]: 606,
};

export const getDefaultJobsCategoryId = (siteCode: SiteCode) => {
  const id = MAP_SITE_CODE_TO_DEFAULT_JOBS_CATEGORY_ID[siteCode];

  if (!id) {
    throw new Error(`Default category id was not set for ${siteCode} site code`);
  }

  return id;
};

export const MAP_SITE_CODE_TO_DEMO_PROFILE_URL: Record<SiteCode, string | null> = {
  [SITE_CODE.OLXPL]: 'https://www.olx.pl/company/1df52bbc-12c4-46fa-9355-ca50898ac05f/',
  [SITE_CODE.OLXRO]: 'https://www.olx.ro/company/5e140eb9-2408-4cd3-a2d4-4f13aae8f033/',
  [SITE_CODE.OLXUA]: 'https://www.olx.ua/company/7863866c-2909-44c0-94a9-0e2823090c93/',
  [SITE_CODE.OLXKZ]: 'https://www.olx.kz/company/b494d0c4-f123-460f-9432-ccacb33d4809/',
  [SITE_CODE.OLXUZ]: null,
  [SITE_CODE.OLXPT]: null,
  [SITE_CODE.OLXBG]: null,
};

export const getDemoProfileURL = (siteCode: SiteCode) => {
  const url = MAP_SITE_CODE_TO_DEMO_PROFILE_URL[siteCode];

  if (!url) {
    throw new Error(`Demo profile URL was not set for ${siteCode} site code`);
  }

  return url;
};
